import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: 'owner-login',
    loadChildren: () => import('./modules/owner/owner.module').then(m => m.OwnerModule),
  },
  {
    path: 'owner',
    loadChildren: () => import('./modules/owner/owner.module').then(m => m.OwnerModule),
  },
  // INC-007b — the EVENT_MARKETOLOG module, double-registered exactly like `owner` above so that
  // `MarketologRoutingModule`'s `{ path: '**', redirectTo: '' }` lands on a login form under BOTH
  // prefixes. Neither entry carries `authGuard`: the marketolog session is a third, independent
  // one (`marketologTokenData`) and must not require an organizer `tokenData`. Order matters —
  // these are literal paths and sit above the `''` cabinet entry.
  {
    path: 'marketolog-login',
    loadChildren: () => import('./modules/marketolog/marketolog.module').then(m => m.MarketologModule),
  },
  {
    path: 'marketolog',
    loadChildren: () => import('./modules/marketolog/marketolog.module').then(m => m.MarketologModule),
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module'),
    canActivate: [authGuard],
  },
  {
    path: '',
    loadChildren: () => import('./modules/cabinet/cabinet.module'),
    canActivate: [authGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
